import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { deleteUser } from "api/services/user-service";
import { useCallback } from "react";

export const useDeleteUser = () => {
    const { callAPI, loading } = useWorkspaceApiCall(deleteUser, 'deleteUser.success', 'deleteUser.error');

    const deleteUserMethod = useCallback(async (userId: string) => {
        return await callAPI({ userId });
    }, [callAPI]);
    
    return { deleteUser: deleteUserMethod, deletingUser: loading };
}